<template>
  <q-page>
    <IAC :id="id" />
  </q-page>
</template>

<script setup>
import IAC from "../components/iac/Iac.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
const route = useRoute();
const id = computed(() => route.params?.id);
</script>
